import { useTranslation } from "react-i18next";

import { AddGameForm } from "./AddGameForm";
import { Container, Heading, LeftSide, RightSide, Section } from "../Common";
import { GameListItem } from "./GameListItem";
import { ImageCover } from "../../../../../shared/ui/ImageCover";
import { useGame } from "../../../../../../contexts/game/GameContext";
import { ActionButtons } from "../Common/ActionButtons";

import styles from "./AddGames.module.scss";

export const AddGames = () => {
  const { games } = useGame();

  const { t: translation } = useTranslation("project");
  const t = (key: string) => translation(`addGames.${key}`);

  return (
    <Container>
      <RightSide>
        <ImageCover />
      </RightSide>
      <LeftSide>
        <Heading title={{ main: t("header1"), marked: t("header2") }}>{t("description")}</Heading>

        <Section title={t("add.label")}>
          <AddGameForm />
        </Section>

        {games.length > 0 && (
          <Section title={t("list.label")}>
            <div className={styles.gamesList}>
              {games.map((game) => (
                <GameListItem key={game.id} game={game} />
              ))}
            </div>
          </Section>
        )}
      </LeftSide>
      <ActionButtons />
    </Container>
  );
};
